<app-base-dialog sizeClass="size-7-75" [noPadding]="true">
	<div>
		<div class="option" (click)="dialogRef.close('asc')">
			<app-icon name="sorteren-oplopend" color="typography-5" size="small"></app-icon>
			<span>Oplopend</span>
		</div>
		<div class="option" (click)="dialogRef.close('desc')">
			<app-icon name="sorteren-aflopend" color="typography-5" size="small"></app-icon>
			<span>Aflopend</span>
		</div>
	</div>
</app-base-dialog>
